// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"beedacaf","396":"da40a0a4","455":"e4a85797","977":"aee2dc24"}[chunkId] + ".chunk.js";
};